import { render, staticRenderFns } from "./afterSalesDetall.vue?vue&type=template&id=44d2255f&scoped=true&"
import script from "./afterSalesDetall.vue?vue&type=script&lang=js&"
export * from "./afterSalesDetall.vue?vue&type=script&lang=js&"
import style0 from "./afterSalesDetall.vue?vue&type=style&index=0&id=44d2255f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d2255f",
  null
  
)

export default component.exports